// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSocialTeams = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.498 10.027a1.802 1.802 0 0 1-.955-.966 1.843 1.843 0 0 1 0-1.408 1.785 1.785 0 0 1 3.302 0c.187.451.187.958 0 1.408a1.784 1.784 0 0 1-2.347.966zM18.404 16.773v-5.455H22v3.575c.013.322-.077.639-.256.905-.17.24-.392.438-.65.579-.272.15-.566.253-.87.307-.304.058-.611.087-.92.089zM16.187 8.89c-.22.095-.457.143-.695.142a1.698 1.698 0 0 1-.694-.142.897.897 0 0 1-.191-.118c-.063-.046-.132-.098-.248-.155V5.822c.116-.056.185-.108.248-.155a.897.897 0 0 1 .19-.117 1.7 1.7 0 0 1 .692-.142c.24-.002.476.047.696.142.43.184.772.53.955.966a1.84 1.84 0 0 1 .001 1.408c-.182.435-.524.78-.954.966zM14.587 18.272a4.227 4.227 0 0 0-.228-.057v-8.033h3.37v6.311c.013.317-.065.631-.225.904-.145.234-.34.43-.573.575a2.379 2.379 0 0 1-.768.303 3.938 3.938 0 0 1-.81.089c-.177-.001-.354-.014-.528-.04a1.713 1.713 0 0 1-.238-.052z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.685 22 2 19.955V4.045L13.685 2zM5.146 9.726l2.023-.082v5.833l1.348.08V9.591l2.022-.091V8.136l-5.393.332z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSocialTeams;
